import { GoogleAuthProvider, getAuth } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAXgJEPCYq3UbfFwdz5iVSZ6aFcYDV8-Tw",
  authDomain: "surveypolls.keeta.net",
  projectId: "electionfever-e397b",
  storageBucket: "electionfever-e397b.appspot.com",
  messagingSenderId: "303544224747",
  appId: "1:303544224747:web:d542c8816a61f15f8ca7ae",
  measurementId: "G-N39HNK89MP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

export const functions = getFunctions(app);
// Uncomment the following line if you want to use the emulator during development
// connectFunctionsEmulator(functions, "127.0.0.1", 5001);

export const db = getFirestore(app);

export const googleProvider = new GoogleAuthProvider();

// Function to check online status
export const isOnline = (): boolean => {
  return window.navigator.onLine;
};
